import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicPageLayout from '../../components/layout/PublicPageLayout';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiSend, FiInbox, FiSearch, FiFileText, FiCheckCircle, FiArrowRight } = FiIcons;

const HowItWorksPage = () => {
  const navigate = useNavigate();

  const steps = [
    { id: 1, title: "Varsel sendes inn", description: "Varsleren bruker det digitale skjemaet (via QR-kode eller lenke). Man kan legge ved bilder/dokumenter og velge å være anonym.", icon: FiSend, color: "bg-blue-100 text-blue-600" },
    { id: 2, title: "Mottak og bekreftelse", description: "Systemet sender automatisk mottaksbekreftelse. Varsleren får en unik tilgangskode for å kunne logge inn og følge saken trygt.", icon: FiInbox, color: "bg-purple-100 text-purple-600" },
    { id: 3, title: "Vurdering og dialog", description: "Saksbehandler mottar varselet. Via den sikre chatten kan man stille oppfølgingsspørsmål til varsleren, selv om vedkommende er anonym.", icon: FiSearch, color: "bg-orange-100 text-orange-600" },
    { id: 4, title: "Saksbehandling", description: "Saken utredes i henhold til arbeidsmiljøloven. Systemet har støtte for møtereferater, tidsfrister og dokumentasjon av kontradiksjon.", icon: FiFileText, color: "bg-indigo-100 text-indigo-600" },
    { id: 5, title: "Konklusjon og lukking", description: "Når saken er ferdig, skrives en sluttrapport. Varsler informeres om utfallet, og saken arkiveres forskriftsmessig i systemet.", icon: FiCheckCircle, color: "bg-green-100 text-green-600" }
  ];

  return (
    <PublicPageLayout 
      title="Slik fungerer prosessen" 
      subtitle="Fra varsel til løsning – steg for steg."
      activePage="/hvordan-fungerer-det"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Timeline */}
        <div className="relative space-y-12 mb-20">
          {/* Connecting Line */}
          <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-gray-200 hidden md:block"></div>

          {steps.map((step, index) => (
            <div key={step.id} className="relative flex flex-col md:flex-row gap-8 items-start">
              {/* Icon Bubble */}
              <div className={`w-16 h-16 rounded-2xl flex items-center justify-center flex-shrink-0 z-10 ${step.color} shadow-sm border-4 border-white`}>
                <SafeIcon icon={step.icon} className="text-2xl" />
              </div>
              {/* Content */}
              <div className="flex-1 bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow pt-2 md:pt-6">
                <div className="flex items-center gap-3 mb-2">
                  <span className="bg-gray-100 text-gray-600 font-bold text-xs px-2 py-1 rounded">Steg {step.id}</span>
                  <h3 className="text-xl font-bold text-slate-900">{step.title}</h3>
                </div>
                <p className="text-slate-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Summary / CTA */}
        <div className="bg-slate-900 text-white rounded-3xl p-10 text-center shadow-xl">
          <h2 className="text-3xl font-bold mb-4">Enkelt for varsleren, trygt for bedriften</h2>
          <p className="text-slate-300 mb-8 max-w-2xl mx-auto">
            Systemet guider dere gjennom hele prosessen og sørger for at lovkrav som frister, taushetsplikt og dokumentasjon blir ivaretatt automatisk.
          </p>
          {/* FIXED NAV LINK */}
          <button onClick={() => navigate('/book-demo')} className="bg-white text-slate-900 px-8 py-4 rounded-xl font-bold hover:bg-gray-100 transition-colors inline-flex items-center gap-2">
            Bestill demo <SafeIcon icon={FiArrowRight} />
          </button>
        </div>
      </div>
    </PublicPageLayout>
  );
};

export default HowItWorksPage;